<template>
    <div class="panel panel-default panel-wntable">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $_locale('reservations') }}</h3>
        </div>
        <div class="panel-body" style="padding: 0;">
            <div class="dataTables_wrapper wn-datatable">
                <div class="table-responsive">
                    <table class="table table-bordered table-hover table-striped table-condensed no-footer" 
                           style="border-top: 1px solid #ddd;margin-bottom:0px;">
                        <tbody>
                        <tr>
                            <th>{{ $_locale('order number') }}</th>
                            <th>{{ $_locale('created') }}</th>
                            <th>{{ $_locale('name') }}</th>
                            <th>{{ $_locale('reservation') }}</th>
                            <th>{{ $_locale('quantity') }}</th>
                            <th style="min-width: 65px;"></th>
                        </tr>
                        <tr v-for="(reservation, index) in reservation.reservations" v-bind:key="index">
                            <td>
                                <a v-bind:href="orderLinkUrl(reservation.orderId)" target="_blank">
                                    {{ reservation.orderId }}
                                </a>
                            </td>
                            <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, reservation.dateCreated) }}</td>
                            <td>{{ reservation.firstName }} {{ reservation.lastName }}</td>
                            <td>
                                {{ $_formatDateTime($_dateFormat.DATETIME_HI, reservation.start) }}
                                -
                                {{ $_formatDateTime($_dateFormat.DATETIME_HI, reservation.end) }}
                            </td>
                            <td>{{ reservation.resources[0].quantity }}</td>
                            <td>
                                <button class="btn btn-xs btn-default"
                                    @click="selectReservation(reservation)">
                                    <i class="glyphicon glyphicon-pencil"></i>
                                </button>
                                <button class="btn btn-xs btn-danger" 
                                    @click="deactivateReservationTime(reservation.reservationTimeId)">
                                    <i class="glyphicon glyphicon-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['reservation'], // reservation block from reservationservice
    computed: {
        ...mapGetters({
            orderLinkUrl: 'ecom/orderLinkUrl',
            date: 'reservations/date',
        }),
    },
    methods: {
        selectReservation(reservation) {
            const status = reservation.isCart ? _locale('in cart').ucfirst() : _locale('reserved').ucfirst();
            const block = { 
                ...this.reservation.block,
                info: `${ status }: ${ reservation.firstName } ${ reservation.lastName }`
            }
            
            this.$store.commit('calendar/setEditReservation', { block, reservation, cacheActiveReservation: true })
            this.$store.commit('common/setModal', 'editreservation')
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);
                    
                    EcomService.deactivateReservationTime(reservationTimeId)
                        .then((response) => {
                            const { data } = response;
                            
                            if (data.success) {
                                this.$store.dispatch('reservations/onDateChange', this.date);
                                
                                this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                            } else {
                                this.$_swal({ icon: 'error', title: data.message })
                            }
                        })
                }
            })
        },
    }
}
</script>
